import httpClient from '@/libs/http-client'

//PT 요청 리스트
export function creditApplyList(data) {
  const url = '/api/super/credit/list'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

//PT 요청 승인
export function creditUpdateStatus(data) {
  const url = '/api/super/credit/updateStatus'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}


export function cashIn(data) {
  const url = '/api/super/credit/deposit'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function cashOut(data) {
  const url = '/api/super/credit/withdraw'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}


export function subPointIn(data) {
  const url = '/api/super/credit/point/deposit'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function subPointOut(data) {
  const url = '/api/super/credit/point/withdraw'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
